import { PersonaRequestBody } from './PersonaRequestBody';

/**
 * @public
 */
export interface GetModelVariableFilterSearchResultRequestBody
  extends PersonaRequestBody {
  Models: string;
}
